import { useEffect, useRef } from 'react';
import { useStore } from '../lib/store.ts';
import { mailRefreshMs, stroomStore } from '../state/stroom.ts';

/** Na zo lang weg uit het venster ververst de terugkeer direct. */
export const BACK_AFTER_MS = 15_000;

/**
 * Vers houden zonder refresh (het tabblad Mail): wat in Outlook verandert (vlag weg, gelezen, nieuwe vlag) ververst `refresh` (de lijst,
 * de mappen met tellers en de tellers bovenin) zolang het venster zichtbaar is: elke minuut, of met de stroom van de maildienst verbonden
 * (2.3.2) als vangnet elke tien minuten, want dan komt elke wijziging als melding over de websocket. Bij terugkeer naar het venster na
 * meer dan 15 s weg direct, met of zonder stroom. Altijd de laatste `refresh` (het filter van nu), zonder de timer opnieuw te beginnen.
 */
export function useMailRefresh(refresh: () => void): void {
  const every = useStore(stroomStore, (s) => mailRefreshMs(s.status));
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    let last = Date.now();
    const run = () => {
      last = Date.now();
      latest.current();
    };
    const timer = setInterval(() => {
      if (document.visibilityState === 'visible') run();
    }, every);
    const onBack = () => {
      if (document.visibilityState === 'visible' && Date.now() - last > BACK_AFTER_MS) run();
    };
    document.addEventListener('visibilitychange', onBack);
    window.addEventListener('focus', onBack);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onBack);
      window.removeEventListener('focus', onBack);
    };
  }, [every]);
}
